// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main container must have explicit height */
.chat-content {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  position: relative;
}

/* Parent container requirements */
.chat-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh; /* Critical - must have defined height */
  overflow: hidden;
}

/* Message styling */
.message-container {
  margin-bottom: 1rem;
  width: 100%;
}

/* Assistant avatar */
.avatar-assistant .assistant-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

/* Feedback section */
.feedback-section {
  margin-top: 0rem;
  margin-left: 25px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.feedback-buttons {
  display: flex;
  gap: 2px;
}

.feedback-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 4px;
  background: none;
  cursor: pointer;
  font-size: 1rem;
  width: 36px;
  height: 36px;
  padding: 0;
  transition: background-color 0.2s ease;
}

.feedback-btn i {
  font-size: 1.1rem;
  color: #444;
}

.feedback-btn:hover {
  background-color: #f5f5f5;
}

.feedback-btn.selected {
  background-color: #d0eaff;
}

.feedback-thankyou {
  font-size: 0.9rem;
  color: #28a745;
  margin: 0;
  font-weight: 500;
}

/* iOS specific fixes */
@supports (-webkit-touch-callout: none) {
  .chat-content {
    -webkit-overflow-scrolling: touch;
  }
}

/* Mobile responsive styles */
@media screen and (max-width: 576px) {
  .feedback-section {
    margin-left: 15px;
    gap: 8px;
  }
  .feedback-btn {
    width: 30px;
    height: 30px;
    font-size: 0.9rem;
  }
  .feedback-btn i {
    font-size: 1rem;
  }
  .feedback-thankyou {
    font-size: 0.8rem;
  }
}

/* Thinking indicator spinner */
.spinner {
  display: flex;
  align-items: center;
  gap: 8px;
}

.loader {
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3498db;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

`, "",{"version":3,"sources":["webpack://./src/components/ChatMessages.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAE,wCAAwC;EACvD,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE;IACE,iCAAiC;EACnC;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC","sourcesContent":["/* Main container must have explicit height */\n.chat-content {\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n/* Parent container requirements */\n.chat-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100vh; /* Critical - must have defined height */\n  overflow: hidden;\n}\n\n/* Message styling */\n.message-container {\n  margin-bottom: 1rem;\n  width: 100%;\n}\n\n/* Assistant avatar */\n.avatar-assistant .assistant-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n}\n\n/* Feedback section */\n.feedback-section {\n  margin-top: 0rem;\n  margin-left: 25px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.feedback-buttons {\n  display: flex;\n  gap: 2px;\n}\n\n.feedback-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 4px;\n  background: none;\n  cursor: pointer;\n  font-size: 1rem;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  transition: background-color 0.2s ease;\n}\n\n.feedback-btn i {\n  font-size: 1.1rem;\n  color: #444;\n}\n\n.feedback-btn:hover {\n  background-color: #f5f5f5;\n}\n\n.feedback-btn.selected {\n  background-color: #d0eaff;\n}\n\n.feedback-thankyou {\n  font-size: 0.9rem;\n  color: #28a745;\n  margin: 0;\n  font-weight: 500;\n}\n\n/* iOS specific fixes */\n@supports (-webkit-touch-callout: none) {\n  .chat-content {\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n/* Mobile responsive styles */\n@media screen and (max-width: 576px) {\n  .feedback-section {\n    margin-left: 15px;\n    gap: 8px;\n  }\n  .feedback-btn {\n    width: 30px;\n    height: 30px;\n    font-size: 0.9rem;\n  }\n  .feedback-btn i {\n    font-size: 1rem;\n  }\n  .feedback-thankyou {\n    font-size: 0.8rem;\n  }\n}\n\n/* Thinking indicator spinner */\n.spinner {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.loader {\n  border: 2px solid #f3f3f3;\n  border-top: 2px solid #3498db;\n  border-radius: 50%;\n  width: 16px;\n  height: 16px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
